import 'modernizr'; // eslint-disable-line
import '../vendor/bootstrap';

import tracking from '../modules/tracking';
import header from '../modules/header';
import videoOverlay from '../modules/videoOverlay';
import slider from '../modules/slider';
import integrationSlider from '../modules/integrationSlider';
import reviewSlider from '../modules/reviewSlider';
import toggle from '../modules/toggle';
import embedWrap from '../modules/embedWrap';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import mediaRow from '../modules/mediaRow';
import controlledInput from '../modules/controlledInput';
import videoElement from '../modules/videoElement';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  header.initialize();
  videoOverlay.initialize();
  slider.initialize();
  integrationSlider.initialize();
  reviewSlider.initialize();
  toggle.initialize();
  embedWrap();
  alert.initialize();
  mediaRow.initialize();
  controlledInput.initialize();
  videoElement.initialize();

  $('[data-toggle="tooltip"]').tooltip();
};

export default general;
